import React from 'react';

const AskAQuestionIcon = () => (
  <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_dd_5398_34648)">
  <rect x="5" y="1" width="44" height="44" rx="10" fill="url(#paint0_linear_5398_34648)" shapeRendering="crispEdges"/>
  <path d="M23.5846 29.6666C25.1751 30.4825 27.0047 30.7035 28.7437 30.2898C30.4827 29.876 32.0168 28.8548 33.0694 27.4101C34.1221 25.9654 34.6242 24.1922 34.4851 22.4101C34.3461 20.628 33.5751 18.9541 32.3111 17.6901C31.0472 16.4261 29.3733 15.6552 27.5912 15.5161C25.809 15.3771 24.0359 15.8792 22.5912 16.9318C21.1464 17.9845 20.1252 19.5185 19.7115 21.2576C19.2978 22.9966 19.5188 24.8261 20.3346 26.4166L18.668 31.3333L23.5846 29.6666Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M24.5742 20.5C24.7701 19.943 25.1568 19.4734 25.6658 19.1743C26.1748 18.8751 26.7733 18.7658 27.3552 18.8656C27.9371 18.9654 28.4649 19.2679 28.8451 19.7196C29.2253 20.1713 29.4334 20.7429 29.4326 21.3333C29.4326 23 26.9326 23.8333 26.9326 23.8333" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M27 27.1667H27.0083" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
  <filter id="filter0_dd_5398_34648" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_dropShadow_5398_34648"/>
  <feOffset dy="2"/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5398_34648"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_5398_34648"/>
  <feOffset dy="4"/>
  <feGaussianBlur stdDeviation="3"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
  <feBlend mode="normal" in2="effect1_dropShadow_5398_34648" result="effect2_dropShadow_5398_34648"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5398_34648" result="shape"/>
  </filter>
  <linearGradient id="paint0_linear_5398_34648" x1="27" y1="1" x2="27" y2="45" gradientUnits="userSpaceOnUse">
  <stop stopColor="#0079C2"/>
  <stop offset="1" stopColor="#005A93"/>
  </linearGradient>
  </defs>
  </svg>
);

export default AskAQuestionIcon;
